import type { Scene } from '@babylonjs/core/scene';
import { CreateBox } from '@babylonjs/core/Meshes/Builders/boxBuilder';
import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Color3 } from '@babylonjs/core/Maths/math.color';

/** Small directional pistol tracer, distinct from magical projectiles. */
export class BulletView {
  private readonly mesh;
  constructor(scene:Scene){
    this.mesh=CreateBox('pistol-tracer',{width:0.09,height:0.07,depth:0.65},scene);
    const material=new StandardMaterial('pistol-tracer',scene);material.disableLighting=true;
    material.emissiveColor=Color3.FromHexString('#ffed99');this.mesh.material=material;this.mesh.isPickable=false;
  }
  update(x:number,y:number,z:number,fx:number,fz:number,_dt:number){this.mesh.position.set(x,y,z);this.mesh.rotation.y=Math.atan2(fx,fz);}
  dispose(){this.mesh.dispose(false,true);}
}
